<mat-card class="station-card station-card-override">
  <mat-card-header>
    <mat-card-title>
      <h3 class="m-0">
        <span class="name">{{ stationItem.name }}</span>
        <app-badge-station [mergedStation]="stationItem"></app-badge-station>
        <span class="float-right band"
          >{{ stationItem.frequency | formatFrequency: stationItem.band }}
          {{ stationItem.band }}</span
        >
      </h3>
    </mat-card-title>
  </mat-card-header>
  <div class="image-content">
    <div class="image-hover">
      <div class="image-hover-content">
        <div class="image-hover-item">
          <app-station-card-hover
            icon="{{
              isPlaying(stationItem.id)
                ? 'pause_circle_filled'
                : 'play_circle_filled'
            }}"
            label="Listen Live"
            (eventClick)="chooseDialogPlay(stationItem)"
          >
          </app-station-card-hover>
        </div>
      </div>
    </div>
    <img
      mat-card-image
      [src]="stationItem.logoUrl"
      alt=""
      class="image"
      (error)="setPlaceholderImage()"
    />
  </div>
  <mat-card-content class="content">
    <div class="my-1 content-info">
      {{ stationItem.format | truncateText: 23 }}
    </div>
    <div class="my-1 content-info">
      {{ stationItem.market | marketFormat | truncateText: 30 }}
    </div>
    <mat-checkbox
      [(ngModel)]="stationItem.favorite"
      class="icon"
      (ngModelChange)="onFavoriteChange($event)"
    >
      <mat-icon
        [ngClass]="{
          favorite: stationItem.favorite,
          unfavorite: !stationItem.favorite
        }"
        >favorite</mat-icon
      >
    </mat-checkbox>
  </mat-card-content>
</mat-card>
